
import { Component, Prop, Vue } from 'nuxt-property-decorator'

import OfferCardDiscountLabel from '~/components/offer-card/OfferCardDiscountLabel.vue'

import type { Theme } from '~/types/theme'

@Component({
  components: {
    OfferCardDiscountLabel,
  },
})
export default class SimpleOfferCardPrice extends Vue {
  @Prop({ type: Number, default: 0 })
  readonly regularPrice!: number

  @Prop({ required: true, default: 0, type: Number })
  readonly finalPrice!: number

  @Prop({ required: true, default: 0, type: Number })
  readonly effectivePercent!: number

  @Prop({ required: false, default: '', type: String })
  readonly theme!: Theme
}
